import {statisticQueryService, statisticQueryServiceUS, statisticQueryServiceAU, statisticQueryServiceAS} from '../index'

class Statistics {
    getResourceStatistic = (id, query) => statisticQueryService.get(`resource/${id}/statistic${query}`)
    getResourceStatisticUS = (id, query) => statisticQueryServiceUS.get(`resource/${id}/statistic${query}`)
    getResourceStatisticAU = (id, query) => statisticQueryServiceAU.get(`resource/${id}/statistic${query}`)
    getResourceStatisticAS = (id, query) => statisticQueryServiceAS.get(`resource/${id}/statistic${query}`)
    getStateChangedLogs = (id, query) => statisticQueryService.get(`resource/${id}/state-changed-logs${query}`)
    getStateChangedLogsUS = (id, query) => statisticQueryServiceUS.get(`resource/${id}/state-changed-logs${query}`)
    getStateChangedLogsAU = (id, query) => statisticQueryServiceAU.get(`resource/${id}/state-changed-logs${query}`)
    getStateChangedLogsAS = (id, query) => statisticQueryServiceAS.get(`resource/${id}/state-changed-logs${query}`)
    getJobStatistics = (id, params) => statisticQueryService.get(`heartbeat/${id}/statistic`, {params})
    getJobEvents = (id, query) => statisticQueryService.get(`heartbeat/${id}/events${query}`)
    getServerResourceMetrics = (id, query) => statisticQueryService.get(`server-resource/${id}/metrics${query}`)
    getLogs = (query) => statisticQueryService.get(`logs${query}`)
}

export default new Statistics()
